import React from 'react';
import {TimelineEvent} from 'react-event-timeline';
import './AppointmentCard.css';
import PrimaryButton from './../PrimaryButton/PrimaryButton';
import CancelButton from './../CancelButton/CancelButton';



class AppointmentCard extends React.Component {
  constructor(){
      super();
      this.state={
          isEditing:false,
          dateEdited: null,
          notesEdited: null,
          hourEdited:null,
          minuteEdited:null
      }
  }

  internalSaveEditHandler = () => {
    const {id} = this.props.appointment;
    const {dateEdited, notesEdited, hourEdited, minuteEdited} = this.state;
    if(dateEdited === ""){
        this.setState({isError:true});
        return;
    }

    if(notesEdited === ""){
        this.setState({isError:true});
        return;
    }

    if(hourEdited === ""){
        this.setState({isError:true});
        return;
    }

    if(minuteEdited === ""){
        this.setState({isError:true});
        return;
    }

    this.props.editHandler({id:id, date: dateEdited, hour: hourEdited, minute: minuteEdited, notes:notesEdited });  
    this.setState({isEditing:false});
  }

  internalEditHandler = () => {
      this.setState({isEditing:true});
  }

  internalCancelHandler = () => {
    this.setState({isEditing:false});
  }

  componentDidMount = () => {
    const {date, hour, minute, notes} = this.props.appointment;
    this.setState({
        dateEdited: date,
        notesEdited: notes,
        hourEdited: hour,
        minuteEdited: minute
    });
  }

  render() {
    const {date, hour, minute, notes} = this.props.appointment;
    const {dateEdited, notesEdited, hourEdited, minuteEdited} = this.state;
    const {deleteHandler, appointment} = this.props;
    const {isEditing, isError} = this.state;

    const dateContent = (
        <div>
            <span className="appointment-card date">{`${ date } ${ hour }:${ minute} hrs`}</span>   
            <i className="fa fa-trash appointment-card trash-button" onClick={()=> deleteHandler(appointment)}></i>
        </div>
    ) 
    return (
        <div>
            {isEditing?
                <TimelineEvent
                title={<span className="appointment-card title">Editando</span>}
                createdAt=""
                bubbleStyle={{
                    "background-color":"#ABD1F9",
                    "border":"none",
                }}
                icon={<i className="fa fa-calendar appointment-card icon"></i>}
                >
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label>Fecha</label>
                            <input 
                                className="form-control"
                                type="date" 
                                onChange={(evt) => this.setState({dateEdited: evt.target.value})} 
                                value={dateEdited}></input>
                        </div>
                        <div className="form-group col-md-4">
                            <label>Hora</label>
                            <input 
                                className="form-control"
                                type="number" 
                                placeholder="00 hrs" 
                                onChange={(evt) => {
                                    const {value} = evt.target;
                                    if(value > 0 && value <= 23){
                                        this.setState({hourEdited: value});
                                    }else{
                                        this.setState({hourEdited: ""});
                                    }
                                }}
                                value={hourEdited}></input>

                        </div>
                        <div className="form-group col-md-4">
                            <label>Minuto</label>
                            <input
                                className="form-control" 
                                type="number" 
                                placeholder="minuto" 
                                onChange={(evt) => {
                                    const {value} = evt.target;
                                    if(value > 0 && value <= 59){
                                        this.setState({minuteEdited: value});
                                    }else{
                                        this.setState({minuteEdited: ""});
                                    }
                                }} 
                                value={minuteEdited}></input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Notas</label>
                            <textarea 
                                className="form-control"
                                onChange={(evt) => this.setState({notesEdited: evt.target.value})} 
                                value={notesEdited}>
                            </textarea>
                        </div>
                    </div>
                    {isError ?
                        <div className="row">
                            <div className="col-md-12">
                                <p className="error">Recuerda que todos los campos son obligatorios</p>
                            </div>
                        </div> 
                        :
                        null
                    }
                    <div className="row">
                        <div className="col-md-3 col-md-offset-6 text-right">
                            <CancelButton 
                                onClick={this.internalCancelHandler}
                                text="Cancelar"/> 
                        </div>
                        <div className="col-md-3 text-right">
                            <PrimaryButton 
                                onClick={this.internalSaveEditHandler}
                                text="Guardar"/> 
                        </div>
                    </div>
                </TimelineEvent>
            :
                <TimelineEvent
                        title={<span className="appointment-card title">Notas</span>}
                        createdAt={dateContent}
                        bubbleStyle={{
                            "background-color":"#ABD1F9",
                            "border":"none",
                        }}
                        icon={<i className="fa fa-calendar appointment-card icon"></i>}
                >
                    <div className="row">
                        <div className="col-md-11">
                            <p className="appointment-card notes">{notes}</p>
                        </div>
                        <div className="col-md-1 text-right">
                            <i 
                                onClick={this.internalEditHandler}
                                className="fa fa-edit appointment-card edit-button"   
                            />
                        </div>
                    </div>
                </TimelineEvent>
            }

        </div>        
    )
  }
}

export default AppointmentCard;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/AppointmentCard/AppointmentCard.js